import { getLocaleText } from "shared/boot/i18n";

export function getContactSortOptions() {
  return [
    {
      type: "outlet",
      options: [
        {
          name: "relevance",
          label: getLocaleText("outreach.contact_sort_options.relevance"),
          tooltip: getLocaleText(
            "outreach.contact_sort_options.relevance_tooltip"
          ),
        },
        {
          name: "name",
          label: getLocaleText("outreach.contact_sort_options.name"),
        },
        {
          name: "outlet_type_name",
          label: getLocaleText("outreach.contact_sort_options.media_type"),
        },
        {
          name: "circulation",
          label: getLocaleText("outreach.contact_sort_options.circulation"),
        },
        {
          name: "frequency",
          label: getLocaleText("outreach.contact_sort_options.frequency"),
        },
        {
          name: "popularity",
          label: getLocaleText("outreach.contact_sort_options.popularity"),
          tooltip: getLocaleText(
            "outreach.contact_sort_options.popularity_outlet_tooltip"
          ),
        },
        {
          name: "content_relevance",
          label: getLocaleText(
            "outreach.contact_sort_options.content_relevance"
          ),
        },
      ],
    },
    {
      type: "influencer",
      options: [
        {
          name: "relevance",
          label: getLocaleText("outreach.contact_sort_options.relevance"),
          tooltip: getLocaleText(
            "outreach.contact_sort_options.relevance_tooltip"
          ),
        },
        {
          name: "name",
          label: getLocaleText("outreach.contact_sort_options.name"),
        },
        {
          name: "business_card_titles",
          label: getLocaleText("outreach.contact_sort_options.job_title"),
        },
        {
          name: "popularity",
          label: getLocaleText("outreach.contact_sort_options.popularity"),
          tooltip: getLocaleText(
            "outreach.contact_sort_options.popularity_influencer_tooltip"
          ),
        },
        {
          name: "content_relevance",
          label: getLocaleText(
            "outreach.contact_sort_options.content_relevance"
          ),
        },
      ],
    },
    {
      type: "all",
      options: [
        {
          name: "relevance",
          label: getLocaleText("outreach.contact_sort_options.relevance"),
          tooltip: getLocaleText(
            "outreach.contact_sort_options.relevance_tooltip"
          ),
        },
        {
          name: "name",
          label: getLocaleText("outreach.contact_sort_options.name"),
        },
        {
          name: "content_relevance",
          label: getLocaleText(
            "outreach.contact_sort_options.content_relevance"
          ),
        },
      ],
    },
  ];
}

export function getContactOutletFields() {
  return [
    {
      name: "name_analysed",
      label: getLocaleText("outreach.contact_fields.name"),
    },
    { name: "owner", label: getLocaleText("outreach.contact_fields.owner") },
    {
      name: "outlet_addresses",
      label: getLocaleText("outreach.contact_fields.address"),
      attributes: [
        "city",
        "state",
        "county",
        "country",
        "time_zone",
        "address_line1",
        "postal_code",
      ],
    },
    {
      name: "email",
      label: getLocaleText("outreach.contact_fields.email"),
      nestedTerms: true,
    },
    {
      name: "profile",
      label: getLocaleText("outreach.contact_fields.profile"),
    },
  ];
}

export function getContactInfluencerFields() {
  return [
    {
      name: "name_analysed",
      label: getLocaleText("outreach.contact_fields.name"),
    },
    {
      name: "influencer_business_cards.title",
      label: getLocaleText("outreach.contact_fields.job_title"),
    },
    {
      name: "twitter_bio",
      label: getLocaleText("outreach.contact_fields.profile"),
    },
    {
      name: "email",
      label: getLocaleText("outreach.contact_fields.email"),
      nestedTerms: true,
    },
    {
      name: "influencer_addresses",
      label: getLocaleText("outreach.contact_fields.address"),
      attributes: [
        "city",
        "state",
        "county",
        "country",
        "time_zone",
        "address_line1",
        "postal_code",
      ],
    },
  ];
}

export function getEmailEventErrorCodes() {
  return [
    {
      code: 452,
      message: getLocaleText("outreach.email_event_error_codes.code_452"),
    },
    {
      code: 498,
      message: getLocaleText("outreach.email_event_error_codes.code_498"),
    },
    {
      code: 550,
      message: getLocaleText("outreach.email_event_error_codes.code_550"),
    },
    {
      code: 552,
      message: getLocaleText("outreach.email_event_error_codes.code_552"),
    },
    {
      code: 554,
      message: getLocaleText("outreach.email_event_error_codes.code_554"),
    },
    {
      code: 602,
      message: getLocaleText("outreach.email_event_error_codes.code_602"),
    },
    {
      code: 605,
      message: getLocaleText("outreach.email_event_error_codes.code_605"),
    },
    {
      code: 612,
      message: getLocaleText("outreach.email_event_error_codes.code_612"),
    },
  ];
}

export default {
  getContactInfluencerFields,
  getContactOutletFields,
  getContactSortOptions,
};
